/* eslint-disable react/no-did-mount-set-state */
import React, { PureComponent } from 'react';
import Raven from 'raven-js';
import { graphql } from 'react-apollo';

import WithAuthService from '@/hocs/withAuthService';

import { UnsubscribeFromEmailType } from '../../state/services/gql/user';
import trackingService from '../../state/services/tracking';
import { SEGMENT_EVENTS } from '../../utils/tracking';

import Container from '../../components/Container';
import LoadingEllipsis from '../../components/LoadingEllipsis';
import Meta from '../../components/Meta';

/**
 * Unsubscribe Email Page component.
 * This page performs an unsubscribe email mutation and returns a static message.
 */
export class UnsubscribeEmailPage extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      error: false,
      success: false,
    };
  }

  async componentDidMount() {
    const {
      mutate,
      router,
      router: {
        params: { variables },
      },
    } = this.props;

    // Clear URL querystring, since this route does not redirect
    router.replace('/unsubscribe-email/thank-you');

    try {
      const parsedVariables = JSON.parse(variables);

      // This mutation may be attemped by an unauth'd user,
      // in which case the `token` param variable is required and renamed
      // in order to override the Bearer header in the GQL client middleware.
      // See `state/services/gql/index.js`.
      const { token, ...rest } = parsedVariables;
      if (!this.props.authService.loggedIn() && !token) {
        throw new Error('Missing token');
      }
      await mutate({
        variables: { authorizationOverrideToken: token, ...rest },
      });
      this.setState({ success: true });

      // Track event
      const { emailAddress, emailType } = parsedVariables;
      trackingService.trackEvent(SEGMENT_EVENTS.EMAIL_UNSUBSCRIBED, {
        emailAddress,
        emailType,
      });
    } catch (error) {
      Raven.captureMessage('Could not unsubscribe email ', error);
      this.setState({ error: true });
    }
  }

  render() {
    const { error, success } = this.state;
    return (
      <div>
        <Meta robots="noindex" />
        {!error && !success ? (
          <LoadingEllipsis />
        ) : (
          <Container>
            {error && <h1>Something went wrong</h1>}
            {success && <h1>Your email settings have been updated</h1>}
          </Container>
        )}
      </div>
    );
  }
}

// Wrap with [GraphQL container](http://dev.apollodata.com/react/api-graphql.html)
export default graphql(UnsubscribeFromEmailType)(
  WithAuthService(UnsubscribeEmailPage),
);
